import { render, staticRenderFns } from "./Karantina.vue?vue&type=template&id=4e5e476c&scoped=true&"
import script from "./Karantina.vue?vue&type=script&lang=js&"
export * from "./Karantina.vue?vue&type=script&lang=js&"
import style0 from "./Karantina.vue?vue&type=style&index=0&id=4e5e476c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e476c",
  null
  
)

export default component.exports